export default __webpack_public_path__ + "static/allinone-762c452d35f18f6e76a1974ace104b62.jpg";